import React, { useState, useEffect } from "react";
import {
    CCard,
    CCardHeader,
    CCardBody,
    CTable,
    CTableBody,
    CTableHead,
    CTableRow,
    CTableHeaderCell,
    CTableDataCell,
    CButton,
    CFormInput,
    CInputGroup,
} from "@coreui/react";
import PrintAccountStatmentLink from "./PrintAccountStatmentLink";

const CustomerSearchWidget = () => {
    const [query, setQuery] = useState("");
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [noData, setNoData] = useState(false); // Add state to track no data

    const handleSearch = async () => {
        setLoading(true);
        try {
            const response = await fetch(`api/customer/search?query=${query}`);
            const data = await response.json();
            if (data.length === 0) {
                setResults([]); // Clear previous results
                setNoData(true); // Set no data flag if data is empty
            } else {
                setResults(data);
                setNoData(false); // Reset no data flag if there are results
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(handleSearch, []);
    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            // Trigger search on Enter key press
            handleSearch();
        }
    };

    return (
        <CCard>
            <CCardHeader>
                <CInputGroup>
                    <CFormInput
                        type="text"
                        placeholder="Search for customers..."
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        onKeyPress={handleKeyPress} // Handle Enter key press
                    />
                    <CButton
                        color="primary"
                        onClick={handleSearch}
                        disabled={loading}
                    >
                        {loading ? "Searching..." : "Search"}
                    </CButton>
                </CInputGroup>
            </CCardHeader>
            <CCardBody>
                {results.length === 0 ? (
                    <div>
                        We couldn't find any data matching your search criteria.
                        It's possible that there are no records that match your
                        current search parameters. To get results, try different
                        search terms or check if your input is accurate. Feel
                        free to explore other options or adjust your filters.
                    </div>
                ) : (
                    <CTable>
                        <CTableHead>
                            <CTableRow>
                                <CTableHeaderCell>Account ID</CTableHeaderCell>
                                <CTableHeaderCell>Name</CTableHeaderCell>
                                <CTableHeaderCell>Address</CTableHeaderCell>
                                <CTableHeaderCell>
                                    Contact Number
                                </CTableHeaderCell>
                                <CTableHeaderCell>
                                    Current Balance
                                </CTableHeaderCell>
                                <CTableHeaderCell></CTableHeaderCell>
                                {/* Add headers for additional fields here */}
                            </CTableRow>
                        </CTableHead>
                        <CTableBody>
                            {results.map((customer) => (
                                <CTableRow key={customer.id}>
                                    <CTableDataCell>
                                        {customer.customer_account_number}
                                    </CTableDataCell>
                                    <CTableDataCell>
                                        {customer.name}
                                    </CTableDataCell>
                                    <CTableDataCell>
                                        {customer.address}
                                    </CTableDataCell>
                                    <CTableDataCell>
                                        {customer.contact_number}
                                    </CTableDataCell>
                                    <CTableDataCell>
                                        {customer.customer_ledger_latest
                                            ?.current_balance || "N/A"}
                                    </CTableDataCell>
                                    <CTableDataCell>
                                        <PrintAccountStatmentLink
                                            customer_account_number={
                                                customer.customer_account_number
                                            }
                                        />
                                    </CTableDataCell>
                                    {/* Add cells for additional fields here */}
                                </CTableRow>
                            ))}
                        </CTableBody>
                    </CTable>
                )}
            </CCardBody>
        </CCard>
    );
};

export default CustomerSearchWidget;
